<template>
  <div>
    <!-- Header -->
    <div class="card card-intro-header shadow-none" :key="updateKey">
      <div class="card-body pr-0">
        <div class="tl-wrapper">
          <div class="tl-l"></div>
          <div class="tl-r">
            <div class="d-flex">
              <div class="flex-grow-1">
                <h4>{{ ticket.subject }}</h4>
                <p class="mb-2" v-if="ticket.agent">
                  Primary agent is <i>{{ ticket.agent.name }}</i>
                </p>
                <p class="text-danger mb-2" v-else>No agent assigned.</p>
                <p class="mb-2">
                  Inbound email is <i class="copy-to-clipboard"
                                      v-clipboard:copy="inboundEmailAddress"
                                      v-clipboard:success="inboundEmailAddressCopied"
                                      v-b-tooltip.hover.bottom title="Click to copy to clipboard">
                  {{ inboundEmailAddress }}
                </i>
                </p>
                <p v-if="incidentReport" class="mb-2">
                  <span class="incident-report-badge" @click="openIncidentReportSidebar">
                    <hazard-icon></hazard-icon>
                    <span class="badge-text">Incident Report</span>
                  </span>
                </p>
                <p v-if="ticket && incompleteTaskCount" class="mb-2 text-danger">
                  <a @click.prevent="setSidebarSection('tasks')" href="#" class="text-danger font-weight-semibold">{{ incompleteTaskCount ? incompleteTaskCount : '-' }} {{ incompleteTaskCount == 1 ? 'task' : 'tasks' }} incomplete</a>
                </p>
                <claim-ticket></claim-ticket>
              </div>
              <div class="flex-shrink-1">
                <div class="btn-group">
                  <a class="btn btn-itg-dark" @click.prevent="collapseAll">
                    <i class="fa fa-chevron-up mr-1"></i>
                    Collapse all
                  </a>
                  <a class="btn btn-itg-dark" @click.prevent="expandAll">
                    <i class="fa fa-chevron-down mr-1"></i>
                    Expand all
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- / Header -->

    <!-- Description -->
    <div class="card card-intro-description shadow-none">
      <div class="card-body pb-2">
        <!-- tl-wrapper -->
        <div class="tl-wrapper tl-header">
          <div class="tl-l">
            <div class="avatar-xs">
              <span
                  class="
                  avatar-title
                  rounded
                  bg-soft-primary
                  text-primary
                  font-size-16
                "
              >
                {{ ticket.agent ? ticket.agent.name.charAt(0) : "?" }}
              </span>
            </div>
          </div>
          <div class="tl-r">
            <div>
              <span class="name">{{ primaryContactName }}</span> reported via
              {{ getHumanReadableTicketSource(ticket.source) }}
            </div>
            <small>
              <i>{{ displayTimestamp(ticket.received_at) }}</i>
            </small>
          </div>
        </div>
        <!-- / tl-wrapper -->
        <!-- tl-wrapper -->
        <div class="tl-wrapper">
          <div class="tl-l"></div>
          <div class="tl-r" v-html="ticket.description"></div>
        </div>
        <!-- / tl-wrapper -->
      </div>
    </div>
    <!-- / Description -->
  </div>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
import PhoneIcon from "../../../../../components/icons/PhoneIcon";
import EmailIcon from "../../../../../components/icons/EmailIcon";
import HazardIcon from "../../../../../components/icons/HazardIcon";
import Dates from "../../../../../mixins/Dates";
import eventBus from "../../../../../event-bus";
import Tickets from "../../../../../mixins/Tickets";
import ClaimTicket from './TicketIntro/ClaimTicket.vue';
import _ from "lodash";

export default {
  name: "TicketIntro",
  created() {
    this.calculateIncompleteTaskCount();
    eventBus.$on('task-added', () => {
      this.$nextTick(() => {
        this.calculateIncompleteTaskCount();
      });
    });
    eventBus.$on('task-toggled', () => {
      this.$nextTick(() => {
        this.calculateIncompleteTaskCount();
      });
    });
  },
  data() {
    return {
      incompleteTaskCount: 0
    }
  },
  computed: {
    ...mapGetters("ticketViewer", {
      ticket: "ticket",
      updateKey: "updateKey",
      incidentReport: "incidentReport"
    }),
    inboundEmailAddress() {
      return 'tickets+' + this.ticket.id + '@insidetravelsupport.com';
    },
    primaryContactName() {
      let primaryContact = _.find(this.ticket.contacts, {
        id: this.ticket.primary_contact_id,
      });

      let name = "Unknown";
      if (primaryContact) {
        name = primaryContact.first_name;
        if (primaryContact.last_name) {
          name = name + " " + primaryContact.last_name;
        }
      }
      return name;
    },
  },
  methods: {
    ...mapActions('ticketViewer', {
      setSidebarSection: 'setSidebarSection'
    }),
    collapseAll() {
      eventBus.$emit('collapse-all');
    },
    expandAll() {
      eventBus.$emit('expand-all');
    },
    inboundEmailAddressCopied() {
      this.$notify.success('Copied to clipboard successfully');
    },
    calculateIncompleteTaskCount() {
      this.incompleteTaskCount = _.filter(this.ticket.tasks, task => {
        return !task.completed_at;
      }).length;
    },
    openIncidentReportSidebar() {
      this.setSidebarSection('incident-report');
    }
  },
  components: {EmailIcon, PhoneIcon, HazardIcon, ClaimTicket},
  mixins: [Dates, Tickets],
};
</script>

<style scoped>
.card-intro-header .card-body {
  padding-bottom: 0 !important;
}

.card-intro-description .card-body {
  padding-top: 0;
}

.copy-to-clipboard {
  cursor: pointer;
}

.incident-report-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background-color: #dc3545;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.incident-report-badge:hover {
  background-color: #c82333;
}

.incident-report-badge svg {
  width: 14px;
  height: 14px;
}

.incident-report-badge .badge-text {
  font-size: 11px;
}

.gap-3 {
  gap: 1rem;
}
</style>
